//Comentario necesario para codificación en UTF-8, ver Inc6743
//03956 Modificacion de nombre y descripcion de la version
(function() {
	var App = angular.module('pphhApp');

	App.controller("versionSelectYearDialogController", ["$scope",  "$mdDialog", "$http", "$window", "pphhEnv", "params", VersionSelectYearDialogController]);
	

	function VersionSelectYearDialogController($scope, $mdDialog, $http, $window, pphhEnv, params) {
        $scope.closeDialog = closeDialog;
		$scope.endSelection = endSelection;
		$scope.year = 2025;

		function closeDialog() {
			$mdDialog.hide();

		}
		
		function endSelection() {
			$scope.isLoading = true;
			var request = {
				method: "POST",
				url: "/pphhNav/ciclo-close/"+$scope.year
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;			
			$http(request).then(
				function(response) {
						if (!response.data.error) {
							$window.location.href = pphhEnv.global.contextPath + "/pphh-sgpusa-init?wm=" + params.wm
						} else {
							var alert = $mdDialog.alert()
								.clickOutsideToClose(true)
								.title(UIMessages.dialog.confirm.title)
								.htmlContent(response.data.messages[0])
								.ok(UIMessages.dialog.confirm.ok)
								;
							$mdDialog.show(alert);
						}
					},
					function(response) {
						$scope.isLoading = false;
					}
			) ;
		}
	}
//$mdDialog.hide($scope.selectedRows);
})();